import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }
      // Request to QNA
      let data = JSON.stringify({
        question: transcript,
        lang: "english",
        client: "akron",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      commit("setIsThinking", true);
      commit("setTextBubbleText", "Thinking....");
      axios
        .request(config)
        .then((response) => {
          console.log("Response from AI: ", response.data);
          commit("setTouchRequest", {
            module: "QnA",
            action: transcript,
            response: response.data.response,
            timeStamp: new Date(),
            requestType: "Speech",
          });
          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: transcript,
                answer: response.data.response,
                confidenceScore: 1,
              },
            },
          });
          dispatch("generateAnswer", response.data.answer);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      if (getters.getIsThinking) {
        commit("setQnaStatus", false);
        const metadata = result.intent.toString();
        const ansObj = result;
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (metadata) {
          case "navigate":
            var menuName = ansObj.metadata.navigateto;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarSpeak", ansObj.answer);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.answer);
            }
            break;

          case "3":
            try {
              var mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.displayPosition.toString() ===
                    ansObj.metadata.mappath.toString(),
                );
              var floorName = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapPath[0].mapFloor);
              dispatch("avatarSpeak", mapPath[0].speech);
              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
                floor: floorName[0].floorName,
              });
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase(),
              );
              dispatch("openImageViewer", {
                name: "Clerk's Office",
                url: mapPath.mapImage,
                floor: "1st Floor",
              });
              dispatch("avatarSpeak", i18n.t("mapNotFound"));
            }

            break;

          case "4":
            dispatch("avatarSpeak", ansObj.response);
            break;

          case "6":
            try {
              console.log("At showform : ", ansObj.metadata);
              var formName = ansObj.metadata.formname;
              console.log("Form Name from QNA: ", formName);
              i18n.t("forms").forEach((form) => {
                if (form.formName.toLowerCase() === formName.toLowerCase()) {
                  dispatch("openPdfViewer", {
                    url: form.document,
                    name: form.formName,
                    emailLink: form.documentUrl,
                    type: "pdf",
                  });
                  dispatch("avatarSpeak", ansObj.response);
                }
              });
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase(),
              );
              dispatch("openImageViewer", {
                name: "Clerk's Office",
                url: mapPath.mapImage,
                floor: "1st Floor",
              });
              dispatch("avatarSpeak", i18n.t("formNotFound"));
            }
            break;
          case "2":
            commit("setQnaKeyword", "");
            var linkId = ansObj.metadata.linkid;
            commit("setQnaKeyword", linkId);
            router.addRoute({
              path: "/faqs",
              component: () => import("@/views/faqs"),
            });
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            var page = i18n
              .t("homepages")
              .filter((page) => page.pageType[0].pathName === "faqs");
            commit("setPageHeader", page[0].pageType[0].pageHeader);

            dispatch("avatarSpeak", ansObj.response);
            break;

          case "0":
            var followUp = ansObj.metadata.followup.split(",");
            dispatch("avatarSpeak", ansObj.response);

            console.log("Follow ups: ", followUp);
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followUp,
            });
            break;
          default:
            mapPath = getters.getMaps.get(
              getters.getDefaultLocation.toLowerCase(),
            );
            dispatch("openImageViewer", {
              name: "Clerk's Office",
              url: mapPath.mapImage,
              floor: "1st Floor",
            });
            dispatch("avatarSpeak", i18n.t("kbError"));
            break;
        }
      }
    },
  },
};
